import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CheckboxLabelPosition } from '../checkbox.config';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.less'],
  providers: [{
    useExisting: forwardRef(() => CheckboxComponent),
    provide: NG_VALUE_ACCESSOR,
    multi: true
  }]
})
export class CheckboxComponent implements OnInit, ControlValueAccessor{
  @Input() label: string;
  @Input() theme: string;
  @Input() customClass: string;
  @Input() isIndeterminate: boolean;
  @Input() isDisabled: boolean;
  @Input() value: boolean;
  @Input() isRequired: boolean = false;
  @Input() iconClass: string;
  @Input() labelPosition: string = CheckboxLabelPosition.horizontal;
  private onChange: any = () => { };
  private onTouch: any = () => { };

  @Output() stateChanged: EventEmitter<boolean> = new EventEmitter();

  constructor() { }
  writeValue(val: boolean): void {
    if (val != null)
      this.value = val;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  ngOnInit(): void { }

  change(event: Event) {
    const target = event.target as HTMLInputElement;
    this.value = target.checked;
    this.onTouch();
    this.onChange(target.checked);
    this.stateChanged.emit(target.checked);
  }
}
